import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: '30px 0',
    
  },
  title: {
    margin: '0 0 12px',
   [theme.breakpoints.down('sm')]:{
    textAlign: 'center'
   }
  },  
  container: {
    marginBottom: theme.spacing(3),
  },
  row: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  datePickerWrapper: {
    width: '230px',
  },
  inputRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
     width: '265px',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
    },
  },
  helpIcon: {
    marginTop: '27px',
    marginLeft: '12px',
    cursor: 'pointer',
  },
}));
